"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchLiquidator__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "host_",
                type: "address",
            },
            {
                internalType: "address",
                name: "cfa_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "ARRAY_SIZES_DIFFERENT",
        type: "error",
    },
    {
        inputs: [],
        name: "cfa",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "deleteFlow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "senders",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "receivers",
                type: "address[]",
            },
        ],
        name: "deleteFlows",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "host",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class BatchLiquidator__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host_, cfa_, overrides) {
        return super.deploy(host_, cfa_, overrides || {});
    }
    getDeployTransaction(host_, cfa_, overrides) {
        return super.getDeployTransaction(host_, cfa_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BatchLiquidator__factory = BatchLiquidator__factory;
BatchLiquidator__factory.bytecode = _bytecode;
BatchLiquidator__factory.abi = _abi;
//# sourceMappingURL=BatchLiquidator__factory.js.map